<template>
    <div  class="IntrView">
    
        <div style="background-color: #1d466b;"><table style="width: 100%; border-collapse: collapse;">
                <tr style="display: flex;justify-content: center;align-items: center;width:100%">  
                  <td><div class="tditem" @click="clicktd(1)" :class="{tditem_active:activeIndex==1}"><div :class="{a_active:activeIndex==1}" ><img src="../../assets/about.png" alt="项目介绍图标" style="vertical-align: middle; ">项目介绍 About</div></div></td>
                  <td><div class="tditem" @click="clicktd(2)" :class="{tditem_active:activeIndex==2}"><div :class="{a_active:activeIndex==2}" ><img src="../../assets/team.png" alt="团队图标" style="vertical-align: middle; ">团队成员 Contributors</div></div></td>
                  <td><div class="tditem" @click="clicktd(3)" :class="{tditem_active:activeIndex==3}"><div :class="{a_active:activeIndex==3}" ><img src="../../assets/list.png" alt="成果列表图标" style="vertical-align: middle;">成果列表 News</div></div></td>
                </tr> 
        </table></div>
        <router-view style="width:100%;"></router-view>
        <el-dialog title="用户登录" :visible.sync="$store.state.logindialog" width="25%">
            <el-form :model="loginForm" label-width="60px">
              <el-form-item label="用户名">
               <el-input v-model="loginForm.username" suffix-icon="el-icon-user"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input type="password" v-model="loginForm.password" suffix-icon="el-icon-lock"></el-input>
              </el-form-item>
          </el-form>
          <div>
            <!-- <el-button @click="this.$store.commit('setLoginDialog', false); ">取消</el-button> -->
            <el-button type="primary" @click="handleLogin" style="margin-left: 10px;">登&nbsp录</el-button>
          </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
  name: 'IndexView',
  data(){
    return{
      message:'hello',
      activeIndex: 1,
      routerutl:[
        '',
        '/intr/indexpage',
        '/intr/item',
        '/intr/achi',
      ],
      
      loginForm: { username: '', password: '' },
      
    };
  },
  
  mounted(){  
    const SessionloginStatus =  sessionStorage.getItem('loginStatus') || '0';
    const loginStatus = localStorage.getItem('loginStatus') || '0';
    if (loginStatus === '0') {
      this.$store.commit('setLoginDialog', true); 
    } else if(SessionloginStatus === '0'){
      this.$axios.get('/api/init').then(res => {
        const resacc=res.data.data.access
        console.log('resacc',resacc);
        console.log('res',res);
        if (res.status === 200) {
          this.$message({
            showClose: true,
            message: '登录状态验证成功',
            type: 'success'
           });
          localStorage.setItem('token', resacc);
          sessionStorage.setItem('loginStatus', '1');
          this.$store.commit('setSessionLoginStatus', '1'); 
          this.$store.commit('setLoginDialog', false); 
        } else {
          localStorage.setItem('loginStatus', '0');
          sessionStorage.setItem('loginStatus', '0');
          this.$store.commit('setSessionLoginStatus', '0'); 
          this.$message({
            showClose: true,
            message: '登录过期',
             type: 'warning'
           });
           this.$store.commit('setLoginDialog', true); 
        }
      }).catch(() => {
        localStorage.setItem('loginStatus', '0');
        sessionStorage.setItem('loginStatus', '0');
        this.$store.commit('setSessionLoginStatus', '0'); 
        this.$store.commit('setLoginDialog', true); 
      });
    }
  },
  methods:{
    handleLogin() {
      if (!this.loginForm.username || !this.loginForm.password) {
        this.$message.error('请输入完整的用户名和密码');
        return;
      }
      this.$axios.post('/api/login', this.loginForm).then(res => {
        console.log(res);
        if (res.status === 200) {
          const resacc=res.data.data.access
          console.log('resacc',resacc);
          localStorage.setItem('token', resacc);
          localStorage.setItem('loginStatus', '1');
          sessionStorage.setItem('loginStatus', '1');
          this.$store.commit('setSessionLoginStatus', '1'); 
          this.$store.commit('setLoginDialog', false); 
          this.$message({
            showClose: true,
            message: '登录成功',
            type: 'success'
           });
        } else {
          this.$message({
            showClose: true,
            message: '用户名或密码错误',
            type: 'warning'
           });
        }
      }).catch(error => {
        
        console.error('登录请求失败:', error);
        this.$message({
            showClose: true,
            message: '登陆失败',
            type: 'warning'
           });
      });
    },
    clicktd(id){
      var path=this.$route.path;
        console.log(this.$route.path);
        var flag=sessionStorage.getItem('loginStatus') || '0';
        console.log(flag);
        if(flag === '0'){
          if(path!='/intr/indexpage')
            this.$router.push('/intr/indexpage');
          this.$message({
            showClose: true,
            message: '请登录后访问',
            type: 'warning'
           });
        }
        else if((id!=this.activeIndex)&&(this.$route.path!=this.routerutl[id])){
          this.$router.push(this.routerutl[id])
            .then(() => {
              this.activeIndex=id
              console.log('导航成功完成');
          })
          .catch(error => {
            console.error('导航被阻止或出错:', error);
          });
          
        }
         
      }
  }


  
}
</script>
<style>
/* .IntrView{
   width:100%;
} */
.IntrView .tditem:hover {
    cursor: pointer;
    background: #f0f0f4 !important; /* 悬停时背景色变为白色 */
    border-radius: 2vh; /* 添加圆角效果 */
    transition: background 0.3s, color 0.3s; /* 平滑过渡效果 */
}
.IntrView .tditem:hover div{
  color: #1d466b !important; /* 悬停时字体颜色变为背景色 */
  font-weight: 600;
}


.IntrView .tditem_active {
    
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f0f0f4 !important; /* 悬停时背景色变为白色 */
    border-radius: 2vh; /* 添加圆角效果 */
    transition: background 0.3s, color 0.3s; /* 平滑过渡效果 */
}

.IntrView .a_active{
  color: #1d466b !important; /* 悬停时字体颜色变为背景色 */
  font-weight: 600;
}
.IntrView .tditem{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1vh 1vw;
  height: 100%;
 margin-left: 2vw;
 margin-right: 2vw;
 font-size: 1.8vh;
  color: #fff;
}

.IntrView table img{
    width: 2vh; /* 图标大小与字体大小一致 */
    height: 2vh;
    margin-right: 1.5vh;
    vertical-align: middle;
}
</style>